module.exports = __webpack_public_path__ + "static/media/5_Jens_Winter_Zertifikate.77485793.jpg";